import api from '../api';

const path = '/favorite';

const addFavoriteRequest = advertId => api.post(`${path}/add`, { advertId });

const deleteFavoriteRequest = id => api.delete(`${path}/delete/${id}`);

export { addFavoriteRequest, deleteFavoriteRequest };
